import React, { useState, useEffect } from "react";
import "./App.css";
import emailjs from '@emailjs/browser';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  //email js support 
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    enquiryType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ show: false, message: '', type: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Your EmailJS credentials
  const serviceId = 'service_6gyt7fi';
  const templateId = 'template_q6an5yj';
  const publicKey = 'DbCcMSP5eAM0Zkms9';

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ show: false, message: '', type: '' });

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      enquiryType: formData.enquiryType,
      message: formData.message,
      time: new Date().toLocaleString('en-US', { 
        dateStyle: 'full', 
        timeStyle: 'medium' 
      })
    };

    emailjs.send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log('Email sent successfully!', response);
        setSubmitStatus({
          show: true,
          message: 'Thank you! Your enquiry has been sent successfully. We will get back to you within 24 hours.',
          type: 'success'
        });
        setFormData({
          name: '',
          email: '',
          phone: '',
          enquiryType: '',
          message: ''
        });
        e.target.reset();
      })
      .catch((error) => {
        console.error('Email sending failed:', error);
        setSubmitStatus({
          show: true,
          message: 'Oops! Something went wrong. Please try again later or call us directly.',
          type: 'error'
        });
      })
      .finally(() => {
        setIsSubmitting(false);
        setTimeout(() => {
          setSubmitStatus({ show: false, message: '', type: '' });
        }, 5000);
      });
  };
  //email support end 
  
  // Lightbox/Slideview state
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Gallery images data
  const galleryImages = [
    { id: 1, category: "Interior", title: "Wardrobes And Lofts", desc: "", src: "/image/img1.jpeg", featured: true },
    { id: 2, category: "Pooja Room", title: "Attached Pooja Room With TV Cabinet", desc: "", src: "/image/img2.jpeg", featured: false },
    { id: 3, category: "Main Bedroom Wardrobes", title: "Wardrobes With Innovative Ideas", desc: "", src: "/image/img3.jpeg", featured: false },
    { id: 4, category: "Kitchen", title: "Modular Kitchen", desc: "", src: "/image/img4.jpeg", featured: false },
    { id: 5, category: "Wardrobe", title: "Wardrobes With Different Varieties", desc: "", src: "/image/img5.jpeg", featured: false },
    { id: 6, category: "Kitchen", title: "Modular Kitchen", desc: "", src: "/image/img6.jpeg", featured: false },
    { id: 7, category: "Rack", title: "Shoe Rack", desc: "", src: "/image/img7.jpeg", featured: false },
    { id: 8, category: "Kitchen", title: "Modular Kitchen", desc: "", src: "/image/img8.jpeg", featured: false },
    { id: 9, category: "Interior", title: "Wardrobe", desc: "", src: "/image/img9.jpeg", featured: false },
    { id: 10, category: "Interior", title: "Wardrobes", desc: "", src: "/image/img10.jpeg", featured: false },
    { id: 11, category: "Study", title: "Study Table", desc: "", src: "/image/img11.jpeg", featured: false },
    { id: 12, category: "Kitchen", title: "Luxury Kitchen", desc: "", src: "/image/img12.jpeg", featured: false },
  ];

  // Lightbox functions
  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen]);

  // Initialize theme
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark-theme');
    } else {
      setIsDark(false);
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark-theme');
    }
  }, []);

  // Handle scroll effect with intersection observer for animations
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
      
      const sections = ['home', 'about', 'services', 'projects', 'packages', 'contact'];
      const scrollPosition = window.scrollY + 100;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);
    
    setTimeout(() => {
      document.querySelectorAll('.scroll-animate').forEach(el => observer.observe(el));
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const toggleDarkMode = () => {
    const newDark = !isDark;
    setIsDark(newDark);
    if (newDark) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark-theme');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark-theme');
      localStorage.setItem('theme', 'light');
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  // Icons
  const MenuIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );

  const CloseIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  const SunIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  );

  const MoonIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
    </svg>
  );

  const ArrowRightIcon = () => (
    <svg className="w-4 h-4 group-hover:translate-x-2 transition-all duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );

  const PlayIcon = () => (
    <svg className="w-5 h-5 transition-transform duration-300 group-hover:scale-110" fill="currentColor" viewBox="0 0 24 24">
      <path d="M8 5v14l11-7z" />
    </svg>
  );

  // Lightbox Icons
  const ChevronLeft = () => (
    <svg className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  );

  const ChevronRight = () => (
    <svg className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );

  const CloseLightboxIcon = () => (
    <svg className="w-6 h-6 md:w-8 md:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  return (
    <div className="app-container">
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled 
          ? 'bg-white/95 dark:bg-gray-900/95 backdrop-blur-md shadow-2xl' 
          : 'bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm border-b border-gray-100 dark:border-gray-800'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <div
  className="flex items-center gap-2 group cursor-pointer"
  onClick={() => scrollToSection('home')}
>
  <div className="relative">
    <div className="absolute inset-0 bg-gradient-to-br from-amber-600 to-orange-600 rounded-xl blur-lg opacity-60 group-hover:opacity-100 transition-all duration-500"></div>
    
    {/* Increased logo size */}
    <div className="relative w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-amber-600 to-orange-600 rounded-xl flex items-center justify-center shadow-md transform group-hover:scale-110 transition-all duration-500 group-hover:rotate-6 overflow-hidden">
      <img
        src="/logo1.jpeg"
        alt="Solid Space Logo"
        className="w-full h-full object-cover rounded-xl"
      />
    </div>
  </div>

  <span className="text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-400 bg-clip-text text-transparent tracking-tight transition-all duration-500 group-hover:tracking-wider">
    SOLID SPACE
  </span>
</div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-1 lg:gap-2">
              {['home', 'about', 'services', 'projects', 'packages', 'contact'].map((section, idx) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className={`relative px-3 lg:px-5 py-2 rounded-lg font-medium transition-all duration-500 group overflow-hidden capitalize text-sm lg:text-base ${
                    activeSection === section
                      ? 'text-amber-600 dark:text-amber-400'
                      : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
                  }`}
                  style={{ transitionDelay: `${idx * 50}ms` }}
                >
                  <span className="relative z-10">{section}</span>
                  <span
                    className={`absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-amber-600 to-orange-600 transition-transform duration-500 ${
                      activeSection === section ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  />
                </button>
              ))}
            </div>

            {/* Right Side Actions */}
            <div className="flex items-center gap-2">
              <button
                onClick={toggleDarkMode}
                className="relative p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-500 hover:scale-110 hover:rotate-12"
                aria-label="Toggle theme"
              >
                <div className="transition-all duration-500">
                  {isDark ? <SunIcon /> : <MoonIcon />}
                </div>
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="hidden sm:flex ml-2 px-5 py-2 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-medium text-sm shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:shadow-amber-500/25 hover:translate-x-1"
              >
                Get A Quote
              </button>
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden relative p-2 rounded-xl bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-500"
              >
                <div className="transition-all duration-500">
                  {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
                </div>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <>
          <div className="fixed inset-0 bg-black/60 backdrop-blur-md z-40 md:hidden animate-fade-in" onClick={() => setIsMenuOpen(false)} />
          <div className="fixed top-0 right-0 h-full w-80 bg-white dark:bg-gray-900 shadow-2xl z-50 md:hidden transform transition-all duration-700 ease-out translate-x-0">
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-gray-800">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-gradient-to-br from-amber-600 to-orange-600 rounded-xl flex items-center justify-center overflow-hidden">
                    <img 
                      src="/logo1.jpeg" 
                      alt="Solid Space Logo" 
                      className="w-full h-full object-cover rounded-xl"
                    />
                  </div>
                  <span className="font-bold text-gray-900 dark:text-white">SOLID SPACE</span>
                </div>
                <button onClick={() => setIsMenuOpen(false)} className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:rotate-90 transition-all duration-500">
                  <CloseIcon />
                </button>
              </div>
              <nav className="flex-1 px-6 py-8 space-y-2">
                {['home', 'about', 'services', 'projects', 'packages', 'contact'].map((section, idx) => (
                  <button
                    key={section}
                    onClick={() => scrollToSection(section)}
                    className={`w-full flex items-center justify-between py-3 px-4 rounded-xl transition-all duration-500 group capitalize transform hover:translate-x-3 ${
                      activeSection === section
                        ? 'bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 text-amber-600 dark:text-amber-400'
                        : 'hover:bg-gray-50 dark:hover:bg-gray-800/50 text-gray-700 dark:text-gray-300'
                    }`}
                    style={{ transitionDelay: `${idx * 80}ms` }}
                  >
                    <span className="font-medium">{section}</span>
                    <ArrowRightIcon />
                  </button>
                ))}
              </nav>
              <div className="p-6 border-t border-gray-100 dark:border-gray-800">
                <button onClick={() => scrollToSection('contact')} className="flex items-center justify-center w-full py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-medium shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105">
                  Get A Quote
                </button>
                <p className="text-xs text-center text-gray-500 dark:text-gray-400 mt-4 transition-all duration-300 hover:text-amber-500">
                  © 2026 Solid Space. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Hero Section */}
      <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden pt-16">
      <div className="absolute inset-0 overflow-hidden">
  {/* Base dark gradient */}
  <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-gray-900 to-black"></div>

  {/* Background image with better blending */}
  <div className="absolute inset-0 bg-[url('/logo1.jpeg')] bg-cover bg-center opacity-25 scale-105 animate-pulse"></div>

  {/* Soft dark overlay for readability */}
  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/70"></div>

  {/* Elegant glowing blobs */}
  <div className="absolute top-10 left-10 w-80 h-80 bg-amber-500/20 rounded-full blur-3xl animate-blob"></div>
  
  <div className="absolute bottom-10 right-10 w-80 h-80 bg-orange-500/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>

  <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl animate-blob animation-delay-4000 -translate-x-1/2 -translate-y-1/2"></div>

  {/* Decorative radial highlight */}
  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,180,50,0.08),transparent_60%)]"></div>
</div>
        
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 backdrop-blur-sm border border-amber-500/30 text-amber-400 px-4 py-2 rounded-full text-sm font-medium mb-6 animate-fade-in-up hover:scale-105 transition-all duration-500">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
            </span>
            100+ Projects Completed • Experience Interior Excellence
          </div>
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold font-[Poppins] mb-6 leading-tight">
  <span className="bg-gradient-to-r from-yellow-300 via-amber-500 to-orange-700 bg-clip-text text-transparent">
    You Set The Bar
  </span>
  <br />
  <span className="bg-gradient-to-r from-stone-200 via-yellow-500 to-amber-700 bg-clip-text text-transparent">
    We Raise The Bar
  </span>
</h1>
          <p className="max-w-2xl mx-auto text-gray-300 text-base sm:text-lg mb-10 animate-fade-in-up animation-delay-400 leading-relaxed hover:text-gray-200 transition-all duration-500">
            We merge architectural integrity and structure to bespoke designs that redefine ultra spaces for the modern family.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 animate-fade-in-up animation-delay-600">
            <button onClick={() => scrollToSection('contact')} className="group inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-medium shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-110 hover:shadow-amber-500/25">
              Start Your Project
              <ArrowRightIcon />
            </button>
            <button onClick={() => scrollToSection('projects')} className="group inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white rounded-xl font-medium hover:bg-white hover:text-gray-900 transition-all duration-500 hover:scale-110">
              <PlayIcon />
              View Projects
            </button>
          </div>
          <div className="flex justify-center gap-4 animate-fade-in-up animation-delay-800">
            <div className="w-8 h-16 border-2 border-gray-400 rounded-full flex justify-center relative hover:border-amber-400 transition-all duration-500">
              <div className="absolute top-2 w-1.5 h-3 bg-amber-400 rounded-full animate-scroll"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Scrolling Tags */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 dark:from-gray-950 dark:to-gray-900 py-3 overflow-hidden border-y border-gray-700">
        <div className="flex animate-marquee whitespace-nowrap hover:animate-pause">
          {['🏗️ Civil Construction', '🎨 Interior Design', '🔨 Renovation', '🏢 Turnkey Projects', '📐 Architectural Design', '⚙️ Structural Engineering', '🌆 Urban Planning', '🌱 Sustainable Builds'].map((item, i) => (
            <span key={i} className="mx-4 text-gray-300 text-xs sm:text-sm font-medium transition-all duration-300 hover:text-amber-400 hover:scale-110 inline-block">● {item}</span>
          ))}
          {['🏗️ Civil Construction', '🎨 Interior Design', '🔨 Renovation', '🏢 Turnkey Projects', '📐 Architectural Design', '⚙️ Structural Engineering', '🌆 Urban Planning', '🌱 Sustainable Builds'].map((item, i) => (
            <span key={i + 100} className="mx-4 text-gray-300 text-xs sm:text-sm font-medium transition-all duration-300 hover:text-amber-400 hover:scale-110 inline-block">● {item}</span>
          ))}
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="py-16 sm:py-24 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 scroll-animate">
            <p className="text-amber-600 dark:text-amber-400 text-xs sm:text-sm uppercase tracking-wider mb-2 font-semibold inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
              PREMIER INTERIOR FIRM
              <span className="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
              About <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">Solid Space</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-orange-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-start">
            <div className="space-y-6 scroll-animate">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-100 dark:bg-amber-900/30 rounded-xl flex items-center justify-center">
                  <span className="text-2xl">🏗️</span>
                </div>
                <h3 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-white">We don't just build — <span className="text-amber-600">we leverage expertise</span></h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-base sm:text-lg pl-14">That encompasses comprehensive project management, innovative architectural solutions and meticulous attention to detail that brings your vision to life with integrity.</p>
              
              <div className="flex gap-4 sm:gap-6 pt-4 pl-14">
                <div className="flex-1 text-center p-4 sm:p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group">
                  <div className="text-3xl mb-2 group-hover:scale-110 transition-transform duration-500">🏆</div>
                  <p className="text-3xl sm:text-4xl font-bold text-amber-600 transition-all duration-500">100+</p>
                  <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-2">Projects Completed</p>
                </div>
              </div>
              
              <button onClick={() => scrollToSection('contact')} className="ml-14 px-6 sm:px-8 py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-medium shadow-lg hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:translate-x-2 inline-flex items-center gap-2">
                <span>Work With Us</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 sm:gap-6 scroll-animate">
              <div className="space-y-4 sm:space-y-6">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group">
                  <div className="w-10 h-10 bg-white dark:bg-gray-800 rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-500">
                    <span className="text-xl">⚙️</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">Accurate Factory CNC Cutting</h4>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group">
                  <div className="w-10 h-10 bg-white dark:bg-gray-800 rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-500">
                    <span className="text-xl">✏️</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">Solid Design's</h4>
                </div>
              </div>
              <div className="space-y-4 sm:space-y-6 mt-6 sm:mt-12">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 p-4 sm:p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group">
                  <div className="w-10 h-10 bg-white dark:bg-gray-800 rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-500">
                    <span className="text-xl">📅</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">45 Days Delivery</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 sm:py-24 bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 scroll-animate">
            <p className="text-amber-600 dark:text-amber-400 text-xs sm:text-sm uppercase tracking-wider mb-2 font-semibold transition-all duration-500 hover:tracking-widest">OUR SERVICES</p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 transition-all duration-500 hover:scale-105">Complete Interior Solution</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-orange-600 mx-auto rounded-full transition-all duration-500 hover:w-32"></div>
            <p className="text-gray-600 dark:text-gray-400 mt-6 max-w-2xl mx-auto text-base sm:text-lg transition-all duration-500 hover:tracking-wide">From design to delivery, we dedicate ourselves to planning and delivering exceptional value to our clients.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
            {[
              { icon: "🍳", title: "Modular Kitchens", features: ["Premium finishes & materials", "Smart storage solutions", "Ergonomic layouts", "Soft-close mechanisms"] },
              { icon: "🚪", title: "Wardrobes & Lofts", features: ["Space-efficient designs", "Customized internal layouts", "Sliding & hinged options", "Mirror finishes available"] },
              { icon: "🍽️", title: "Dining Set", features: ["Solid wood construction", "4/6/8 seater options", "Upholstered chairs available", "Extendable tables option"] },
              { icon: "📚", title: "Study Table", features: ["Ergonomic designs", "Built-in storage drawers", "Cable management system", "Adjustable height options"] },
              { icon: "📺", title: "TV Unit", features: ["Modern minimalist designs", "LED strip integration", "Hidden storage compartments", "Wall-mounted options"] },
              { icon: "🛏️", title: "King/Queen Size Bed", features: ["Hydraulic storage option", "Upholstered headboards", "Solid wood frames", "Side storage drawers"] },
              { icon: "🧱", title: "Partition Wall", features: ["Space division solutions", "Decorative designs", "Glass & wood combinations", "Sliding partition options"] },
              { icon: "🪚", title: "Complete Wood Works", features: ["Custom carpentry solutions", "Wall paneling & moldings", "Premium wood selection", "Precision craftsmanship"] },
              { icon: "✨", title: "False Ceiling", features: ["POP & gypsum designs", "Ambient LED lighting", "Thermal insulation", "Multiple tier options"] },
              { icon: "🔲", title: "Tiling", features: ["Vitrified & ceramic tiles", "Marble & stone options", "Designer patterns", "Anti-skid finishes"] },
              { icon: "🎨", title: "Painting", features: ["Emulsion & texture finishes", "Enamel & metallic options", "Eco-friendly paints", "Waterproofing solutions"] },
              { icon: "🔩", title: "MS Work", features: ["Railings & grills", "Gates & staircases", "Structural frameworks", "Powder coating finishes"] },
              { icon: "💧", title: "Plumbing", features: ["Pipe fitting & installation", "Bathroom plumbing", "Leakage repair", "Water heater connections"] },
              { icon: "⚡", title: "Electricals", features: ["Complete wiring solutions", "Lighting fixtures", "Switchboard installation", "Fan & appliance fitting"] },
            ].map((service, idx) => (
              <div key={idx} className="group bg-white dark:bg-gray-900 rounded-2xl p-4 sm:p-6 shadow-xl hover:shadow-2xl transition-all duration-700 hover:-translate-y-4 hover:scale-105 cursor-pointer scroll-animate border border-gray-100 dark:border-gray-800 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/20 dark:to-orange-900/20 rounded-bl-3xl opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                <div className="text-4xl sm:text-5xl mb-4 transform group-hover:scale-125 transition-all duration-500 group-hover:rotate-6">{service.icon}</div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-3 group-hover:text-amber-600 transition-all duration-500">{service.title}</h3>
                <div className="space-y-2 mb-4">
                  {service.features.map((feature, i) => (
                    <p key={i} className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm flex items-center gap-2"><span className="text-amber-500">✓</span> {feature}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12 sm:mt-16 scroll-animate">
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-amber-600 to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 hover:tracking-wide flex items-center gap-2 mx-auto text-sm sm:text-base cursor-pointer"
            >
              <span>📞</span> Get a Free Consultation
              <span>→</span>
            </button>
            <p className="text-gray-500 dark:text-gray-400 text-xs sm:text-sm mt-4">No obligation. Just expert advice tailored to your needs.</p>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="py-16 sm:py-24 bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 scroll-animate">
            <div className="inline-flex items-center gap-2 bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
              <span className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse"></span>
              OUR PORTFOLIO
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
              Featured <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">Projects</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-orange-600 mx-auto rounded-full"></div>
            <p className="text-gray-600 dark:text-gray-400 mt-6 max-w-2xl mx-auto text-base sm:text-lg">Discover our finest work where creativity meets craftsmanship</p>
          </div>

          {/* Statistics Cards */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-12 sm:mb-20 scroll-animate">
            {[
              { icon: "🏗️", value: "100+", label: "Projects Delivered" },
              { icon: "😊", value: "100+", label: "Happy Clients" },
              { icon: "⭐", value: "4.9", label: "Client Rating" }
            ].map((stat, idx) => (
              <div key={idx} className="group bg-white dark:bg-gray-900 rounded-2xl px-6 sm:px-8 py-5 text-center shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 dark:border-gray-700">
                <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-500 group-hover:rotate-6">{stat.icon}</div>
                <h3 className="text-3xl sm:text-4xl font-bold text-amber-600 dark:text-amber-400">{stat.value}</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-7">
            {galleryImages.map((image, idx) => (
              <div 
                key={image.id} 
                onClick={() => openLightbox(idx)}
                className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 cursor-pointer scroll-animate bg-gray-100 dark:bg-gray-800"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img 
                    src={image.src} 
                    alt={image.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = "https://placehold.co/600x450/e5e7eb/9ca3af?text=Image+Not+Found";
                    }}
                  />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col items-center justify-end p-5">
                    <h3 className="text-white text-lg font-bold mb-1 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500">{image.title}</h3>
                    <p className="text-gray-200 text-sm transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-75">{image.desc}</p>
                    <button className="mt-3 text-amber-400 text-sm font-medium inline-flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                      View Project →
                    </button>
                  </div>
                  
                  <div className="absolute top-3 left-3 bg-black/60 backdrop-blur-sm px-2.5 py-1 rounded-md text-white text-[10px] font-medium">
                    {image.category}
                  </div>
                  
                  {image.featured && (
                    <div className="absolute top-3 right-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[10px] px-2.5 py-1 rounded-md font-semibold shadow-md">
                      Featured
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12 sm:mt-16 scroll-animate">
            <button 
              onClick={() => scrollToSection('contact')}
              className="group px-8 py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 inline-flex items-center gap-2"
            >
              <span>📷</span> View All Projects
              <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Trust Badges */}
          <div className="mt-16 sm:mt-20 pt-8 border-t border-gray-200 dark:border-gray-700 scroll-animate">
            <div className="flex flex-wrap justify-center items-center gap-6 sm:gap-10">
              {[
                { text: "12 Months Defect Liability Period" },
                { text: "20+ Years Experience" },
                { text: "24/7 Customer Support" }
              ].map((badge, idx) => (
                <div key={idx} className="flex items-center gap-2 text-gray-500 dark:text-gray-400">
                  <div className="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <span className="text-xs sm:text-sm">{badge.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-lg flex items-center justify-center animate-fade-in">
          <button 
            onClick={closeLightbox}
            className="absolute top-4 right-4 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-500 hover:scale-110 text-white"
          >
            <CloseLightboxIcon />
          </button>

          <div className="absolute top-4 left-4 z-20 px-4 py-2 rounded-full bg-black/50 text-white text-sm font-medium">
            {currentImageIndex + 1} / {galleryImages.length}
          </div>

          <button 
            onClick={prevImage}
            className="absolute left-4 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-500 hover:scale-110 text-white"
          >
            <ChevronLeft />
          </button>

          <button 
            onClick={nextImage}
            className="absolute right-4 z-20 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-500 hover:scale-110 text-white"
          >
            <ChevronRight />
          </button>

          <div className="relative w-full max-w-6xl mx-auto px-4 sm:px-8">
            <div className="relative overflow-hidden rounded-2xl">
              <img 
                src={galleryImages[currentImageIndex].src}
                alt={galleryImages[currentImageIndex].title}
                className="w-full h-auto max-h-[75vh] sm:max-h-[85vh] object-contain transition-all duration-500"
                onError={(e) => {
                  e.target.src = "https://placehold.co/1200x800/amber-200/orange-200?text=Image+Not+Found";
                }}
              />
              
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <span className="text-amber-400 text-sm font-semibold uppercase tracking-wider">
                  {galleryImages[currentImageIndex].category}
                </span>
                <h3 className="text-white text-2xl md:text-3xl font-bold mt-1">
                  {galleryImages[currentImageIndex].title}
                </h3>
                <p className="text-gray-300 text-base mt-2">
                  {galleryImages[currentImageIndex].desc}
                </p>
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-0 right-0 z-20 hidden sm:block">
            <div className="flex justify-center gap-2 overflow-x-auto px-4 py-2 max-w-full">
              {galleryImages.map((img, idx) => (
                <button
                  key={img.id}
                  onClick={() => setCurrentImageIndex(idx)}
                  className={`flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden transition-all duration-300 ${
                    currentImageIndex === idx 
                      ? 'ring-2 ring-amber-500 scale-110' 
                      : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={img.src} 
                    alt={img.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "https://placehold.co/64x64/e5e7eb/9ca3af?text=No";
                    }}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Packages Section */}
      <section id="packages" className="py-16 sm:py-24 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 scroll-animate">
            <p className="text-amber-600 dark:text-amber-400 text-xs sm:text-sm uppercase tracking-wider mb-2 font-semibold transition-all duration-500 hover:tracking-widest">OUR PACKAGES</p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 transition-all duration-500 hover:scale-105">Choose Your Perfect Plan</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-orange-600 mx-auto rounded-full transition-all duration-500 hover:w-32"></div>
            <p className="text-gray-600 dark:text-gray-400 mt-6 max-w-2xl mx-auto text-base sm:text-lg">Tailored solutions for every budget and requirement — with or without material</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              { 
                icon: "💎", 
                title: "Premium Package", 
                price: "₹900", 
                color: "from-blue-600 to-cyan-600",
                badge: "💎 Best Value",
                gradient: "from-blue-500 to-cyan-500"
              },
              { 
                icon: "⭐", 
                title: "Gold Package", 
                price: "₹1,200", 
                color: "from-amber-600 to-orange-600",
                badge: "⭐ Most Popular",
                gradient: "from-amber-500 to-orange-500",
                popular: true
              },
              { 
                icon: "👑", 
                title: "Luxury Package", 
                price: "₹1,500", 
                color: "from-purple-600 to-pink-600",
                badge: "👑 Ultimate Luxury",
                gradient: "from-purple-500 to-pink-500"
              }
            ].map((pkg, idx) => (
              <div key={idx} className={`group relative bg-white dark:bg-gray-900 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-700 hover:-translate-y-6 hover:scale-105 cursor-pointer scroll-animate ${pkg.popular ? 'border-2 border-amber-500 transform scale-105 hover:scale-110' : 'border border-gray-100 dark:border-gray-800'}`}>
                <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${pkg.gradient}`}></div>
                <div className={`absolute top-4 sm:top-6 right-4 sm:right-6 bg-gradient-to-r ${pkg.gradient} text-white px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold shadow-lg ${pkg.popular ? 'animate-pulse' : ''}`}>
                  {pkg.badge}
                </div>
                <div className="p-5 sm:p-8">
                  <div className="text-5xl sm:text-6xl mb-4 transform group-hover:scale-110 transition-all duration-500 group-hover:rotate-6">{pkg.icon}</div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2">{pkg.title}</h3>
                  <div className="mb-4"><span className={`text-3xl sm:text-4xl font-bold ${pkg.title === 'Gold Package' ? 'text-amber-600 dark:text-amber-400' : pkg.title === 'Premium Package' ? 'text-blue-600 dark:text-blue-400' : 'text-purple-600 dark:text-purple-400'}`}>{pkg.price}</span><span className="text-gray-500 dark:text-gray-400">/sq.ft</span></div>
                  <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mb-4 sm:mb-6 flex items-center gap-2"><span className="inline-block w-2 h-2 bg-green-500 rounded-full"></span>Includes premium quality materials</p>
                  <button onClick={() => scrollToSection('contact')} className={`w-full py-2.5 sm:py-3 rounded-xl font-semibold transition-all duration-500 transform hover:scale-105 bg-gradient-to-r ${pkg.color} text-white shadow-lg hover:shadow-2xl text-sm sm:text-base`}>
                    Get Quote →
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Labour Only Package */}
          <div className="mt-8 sm:mt-12 scroll-animate">
            <div className="bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 rounded-2xl p-5 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className="text-4xl sm:text-5xl">🔧</div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-1">Labour Only Package</h3>
                    <p className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm">Without material — You provide the materials, we provide the expertise</p>
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl sm:text-4xl font-bold text-amber-600 dark:text-amber-400">₹300</div>
                  <div className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">per square foot</div>
                </div>
                <button onClick={() => scrollToSection('contact')} className="px-5 sm:px-8 py-2.5 sm:py-3 bg-gradient-to-r from-gray-700 to-gray-900 dark:from-gray-600 dark:to-gray-800 text-white rounded-xl font-semibold transition-all duration-500 hover:scale-105 hover:shadow-xl text-sm sm:text-base">
                  Get Labour Quote →
                </button>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-gray-300 dark:border-gray-700">
                {['Skilled carpenters', 'Professional electricians', 'Expert plumbers', 'Quality assurance'].map((item, i) => (
                  <div key={i} className="flex items-center gap-2 text-xs sm:text-sm text-gray-600 dark:text-gray-400"><span className="text-green-500">✓</span> {item}</div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-8 text-center scroll-animate">
            <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">* All prices are exclusive of GST. Final cost may vary based on site conditions and specific requirements.</p>
            <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-2">📞 Contact us for a detailed site evaluation and exact quote</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-24 bg-gradient-to-r from-amber-600 via-orange-600 to-red-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-white/10 rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-white/10 rounded-full filter blur-3xl animate-pulse animation-delay-1000"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 transition-all duration-500 hover:scale-105 hover:tracking-wider">Ready to construct your next legacy?</h2>
          <p className="text-amber-100 mb-8 sm:mb-10 max-w-2xl mx-auto text-base sm:text-lg transition-all duration-500 hover:tracking-wide">Partner with SOLID SPACE — no figures are too great for us to start with excellence and deliver with precision.</p>
          <button onClick={() => scrollToSection('contact')} className="inline-flex items-center gap-2 px-8 sm:px-10 py-3 sm:py-4 bg-white text-amber-600 rounded-xl font-semibold shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-110 hover:translate-x-2 text-base sm:text-lg">
            GET STARTED →
          </button>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 sm:py-24 bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 scroll-animate">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4 transition-all duration-500 hover:scale-105">Contact Us</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-orange-600 mx-auto rounded-full transition-all duration-500 hover:w-32"></div>
            <p className="text-gray-600 dark:text-gray-400 mt-6 text-base sm:text-lg">Have a project in mind? Let's work together!</p>
          </div>
          
          {submitStatus.show && (
            <div className={`max-w-5xl mx-auto mb-8 p-4 rounded-xl ${
              submitStatus.type === 'success' 
                ? 'bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-400'
                : 'bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400'
            } transition-all duration-500 animate-fade-in`}>
              <div className="flex items-center gap-3">
                {submitStatus.type === 'success' ? (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                )}
                <p className="text-sm sm:text-base">{submitStatus.message}</p>
              </div>
            </div>
          )}
          
          <div className="grid md:grid-cols-2 gap-8 sm:gap-12 max-w-5xl mx-auto">
            <div className="space-y-6 sm:space-y-8">
              <div className="space-y-4 sm:space-y-6">
                {[
                  { icon: '📍', text: 'Bengaluru, Karnataka 560049', label: 'Address' },
                  { icon: '📞', text: '+91 8217799173', label: 'Phone' },
                  { icon: '✉️', text: 'solidspaces910@gmail.com', label: 'Email' }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3 sm:gap-4 group cursor-pointer scroll-animate">
                    <div className="w-10 h-10 sm:w-14 sm:h-14 bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/30 dark:to-orange-900/30 rounded-xl flex items-center justify-center text-amber-600 text-xl sm:text-2xl group-hover:scale-110 transition-all duration-500 group-hover:rotate-12">
                      {item.icon}
                    </div>
                    <div className="transition-all duration-500 group-hover:translate-x-2">
                      <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">{item.label}</p>
                      <p className="text-gray-800 dark:text-white text-sm sm:text-lg group-hover:text-amber-600 transition-all duration-500">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
              <input 
                type="text" 
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                placeholder="Your Name" 
                className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-500 hover:scale-105 text-sm sm:text-base" 
              />
              <input 
                type="email" 
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="Your Email" 
                className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-500 hover:scale-105 text-sm sm:text-base" 
              />
              <input 
                type="tel" 
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
                placeholder="Your Phone Number" 
                className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-500 hover:scale-105 text-sm sm:text-base" 
              />
              
              <div className="relative">
                <select 
                  name="enquiryType"
                  value={formData.enquiryType}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-500 hover:scale-105 text-sm sm:text-base appearance-none cursor-pointer"
                >
                  <option value="" disabled>Select Enquiry Type</option>
                  <option value="Premium Package">💎 Premium Package</option>
                  <option value="Gold Package">⭐ Gold Package</option>
                  <option value="Luxury Package">👑 Luxury Package</option>
                  <option value="Labour Only Package">🔧 Labour Only Package</option>
                  <option value="Interior Design">🏠 Interior Design</option>
                  <option value="Civil Construction">🏗️ Civil Construction</option>
                  <option value="Modular Kitchen">🍳 Modular Kitchen</option>
                  <option value="Wardrobes & Lofts">🚪 Wardrobes & Lofts</option>
                  <option value="Bedroom Design">🛏️ Bedroom Design</option>
                  <option value="Living Room Design">🛋️ Living Room Design</option>
                  <option value="Exterior/Facade">🏢 Exterior/Facade</option>
                  <option value="Renovation Work">🔨 Renovation Work</option>
                  <option value="Turnkey Project">🔑 Turnkey Project</option>
                  <option value="Free Consultation">💡 Free Consultation</option>
                  <option value="Other Enquiry">📋 Other Enquiry</option>
                </select>
                <div className="absolute right-4 sm:right-6 top-1/2 transform -translate-y-1/2 pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
              
              <textarea 
                rows="4" 
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
                placeholder="Your Message" 
                className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-500 hover:scale-105 text-sm sm:text-base"
              ></textarea>
              
              <button 
                type="submit" 
                disabled={isSubmitting}
                className="w-full py-3 sm:py-4 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-xl font-semibold shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 hover:translate-y-1 text-base sm:text-lg disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending...
                  </div>
                ) : (
                  'Send Message'
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 dark:bg-gray-950 text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
            <div className="scroll-animate">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-amber-600 to-orange-600 rounded-xl flex items-center justify-center shadow-md transition-all duration-500 hover:scale-110 hover:rotate-12 overflow-hidden">
                  <img 
                    src="/logo1.jpeg" 
                    alt="Solid Space Logo" 
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
                <span className="text-xl sm:text-2xl font-bold transition-all duration-500 hover:tracking-wider">SOLID SPACE</span>
              </div>
              <p className="text-gray-400 leading-relaxed text-sm sm:text-base transition-all duration-500 hover:pl-2">We design, build and deliver architectural excellence tailored to your vision, every single time.</p>
            </div>
            <div className="scroll-animate">
              <h4 className="font-semibold text-base sm:text-lg mb-4 sm:mb-6">PROJECTS</h4>
              <ul className="space-y-2 sm:space-y-3 text-gray-400 text-sm sm:text-base">
                {['Residential', 'Commercial', 'Industrial', 'Mixed Use'].map((item, idx) => (
                  <li key={idx} className="transition-all duration-300 hover:text-amber-400 hover:translate-x-2 cursor-pointer">{item}</li>
                ))}
              </ul>
            </div>
            <div className="scroll-animate">
              <h4 className="font-semibold text-base sm:text-lg mb-4 sm:mb-6">SERVICES</h4>
              <ul className="space-y-2 sm:space-y-3 text-gray-400 text-sm sm:text-base">
                {['Civil Construction', 'Interior Design', 'Renovation', 'Turnkey Projects'].map((item, idx) => (
                  <li key={idx} className="transition-all duration-300 hover:text-amber-400 hover:translate-x-2 cursor-pointer">{item}</li>
                ))}
              </ul>
            </div>
            <div className="scroll-animate">
              <h4 className="font-semibold text-base sm:text-lg mb-4 sm:mb-6">CONTACT US</h4>
              <ul className="space-y-2 sm:space-y-3 text-gray-400 text-sm sm:text-base">
                <li className="transition-all duration-300 hover:text-amber-400 hover:translate-x-2">Bengaluru, Karnataka 560049</li>
                <li className="transition-all duration-300 hover:text-amber-400 hover:translate-x-2">+91 8217799173</li>
                <li className="transition-all duration-300 hover:text-amber-400 hover:translate-x-2">solidspaces910@gmail.com</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 text-center text-gray-400">
            <p className="text-xs sm:text-sm transition-all duration-300 hover:text-amber-400">© 2026 Solid Space. All rights reserved.</p>
            <div className="flex justify-center gap-4 sm:gap-6 mt-3 sm:mt-4">
              <span className="text-xs sm:text-sm transition-all duration-300 hover:text-amber-400 hover:translate-x-1 cursor-pointer">Privacy Policy</span>
              <span className="text-xs sm:text-sm transition-all duration-300 hover:text-amber-400 hover:translate-x-1 cursor-pointer">Terms of Service</span>
            </div>
          </div>
        </div>
      </footer>

      {/* CSS Animations */}
      <style>{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes scroll {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(15px); opacity: 0; }
        }
        
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        .animate-blob { animation: blob 10s infinite; }
        .animate-fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards; }
        .animate-scroll { animation: scroll 1.5s infinite; }
        .animate-marquee { animation: marquee 25s linear infinite; }
        .animate-fade-in { animation: fadeIn 0.5s ease-out forwards; }
        .animate-gradient { background-size: 200% auto; animation: gradientShift 3s ease infinite; }
        
        .hover\\:animate-pause:hover { animation-play-state: paused; }
        
        .scroll-animate {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .scroll-animate.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
        
        .animation-delay-200 { animation-delay: 0.2s; }
        .animation-delay-400 { animation-delay: 0.4s; }
        .animation-delay-600 { animation-delay: 0.6s; }
        .animation-delay-800 { animation-delay: 0.8s; }
        .animation-delay-1000 { animation-delay: 1s; }
        .animation-delay-2000 { animation-delay: 2s; }
        
        body.dark-theme { background-color: #111827; }
        body { background-color: #ffffff; }
        
        html {
          scroll-behavior: smooth;
        }
        
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        ::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #f59e0b, #ea580c);
          border-radius: 5px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #d97706, #c2410c);
        }
      `}</style>
    </div>
  );
}

export default App;